import React from "react"
import { Card, CardHeader, CardTitle, CardBody } from "reactstrap"
import Chart from "react-apexcharts"
import { inject, observer } from 'mobx-react';

@observer
class BarCharts extends React.Component {

  render() {
    const {slides} = this.props;
    const categories = slides.map(slide => slide.title + ' [Slide#'+slide.slideNo+']');
    const values = slides.map(slide => Math.floor(slide.duration/1000))

    const settings = {
        options: {
          colors: this.props.themeColors,
          plotOptions: {
            bar: {
              horizontal: true
            }
          },
          dataLabels: {
            enabled: false
          },
          xaxis: {
            categories: categories,
            tickAmount: 5
          }
        },
        series: [
          {
            name: 'Total Time in Sec',
            data: values
          }
        ],
        events: {
            click: function(event, chartContext, config) {

            },
            legendClick: function(chartContext, seriesIndex, config) {

            },
            markerClick: function(event, chartContext, { seriesIndex, dataPointIndex, config}) {

            }
        }
      }


    return (
          <Chart
            options={settings.options}
            series={settings.series}
            type="bar"
            height={350}
          />
    )
  }
}
export default BarCharts
